import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartLineView } from '../../models/cart.model';

// The single line/quantity/total row shared between the cart page and any bottom
// sheet that needs to show cart lines for one item (e.g. the item variants sheet) -
// kept in one place so both stay visually in sync.
@Component({
  selector: 'app-cart-line-item',
  templateUrl: './cart-line-item.component.html',
  styleUrl: './cart-line-item.component.scss',
  standalone: false,
})
export class CartLineItemComponent {
  @Input() line!: CartLineView;
  @Input() readOnly = false;

  @Output() increase = new EventEmitter<void>();
  @Output() decrease = new EventEmitter<void>();
  @Output() editClick = new EventEmitter<void>();
}
